'use client';

import React, { FC, useState } from 'react';

import { useMemberConnectWhatsappMutation } from 'generated/hooks';
import { Button } from 'components/ui/button';
import { SiWhatsapp } from '@icons-pack/react-simple-icons';


interface IWhatsappLogin {}

export const WhatsappLogin: FC<IWhatsappLogin> = (props) => {
  const [error, setError] = useState<string>('');

  const [, whatsAppConnectLink] = useMemberConnectWhatsappMutation();

  const start = async () => {
    const resp = await whatsAppConnectLink({});
    if (resp.error) {
      return setError(() => resp.error?.message ?? '');
    }
    window.location.href = resp.data?.memberConnectWhatsappLink?.link ?? '';
  };

  return (
    <>
      <Button
        variant='green'
        size='x-large'
        className='gap-3 bg-[#60D669] border-[#60D669] hover:bg-[#60D669]/80 hover:border-[#60D669]/80 w-full'
        onClick={start}
      >
        <SiWhatsapp />
        Sign in with Whatsapp
      </Button>
      {!!error && (
        <p className={`text-small text-error-600`}>{error}</p>
      )}
    </>
  );
};
